// extracted by mini-css-extract-plugin
export default {"bannerContainer":"index_snow_bannerContainer__qmo2u","bannerImage":"index_snow_bannerImage__RIIup"};